<template>
  <div
    id="LayoutAuth"
    :style="`background-image:url(${bgImage}); background-size: cover; background-position: center;`"
  >
    <img
      :src="foundeverLogo"
      alt="Foundever logo"
      class="LayoutAuth__icon"
      height="28"
    />
    <div class="LayoutAuth__card">
      <img
        class="LayoutAuth__logo"
        :src="logoSVG"
        alt="Voicebot logo"
        height="28"
        width="116"
        :title="appVersion"
      />
      <div class="LayoutAuth__card-text">
        <h4 class="LayoutAuth__card-text-title">
          Welcome back, <br />good to see you again
        </h4>
        <p class="LayoutAuth__card-text-subtitle">Sign in to your account</p>
      </div>
      <div class="LayoutAuth__router-view">
        <RouterView />
      </div>
    </div>
    <div class="LayoutAuth__footer">© {{ currentYear }} Foundever</div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import bgImage from './assets/background.svg'
import logoSVG from './assets/EverGPT.svg'
import foundeverLogo from './assets/FoundeverLogo.svg'
import packageJson from '../../../package-lock.json'

const currentYear = new Date().getFullYear()
const appVersion = computed(() => packageJson.version)
</script>

<style scoped lang="scss">
#LayoutAuth {
  min-height: 100vh;
  width: 100vw;
  background-color: $color-white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: 100px;
    z-index: 0;
    background-repeat: repeat;
  }

  .LayoutAuth__logo {
    width: max-content;
    height: 28px;
  }

  .LayoutAuth__icon {
    position: absolute;
    top: 40px;
    left: 40px;
  }
  .LayoutAuth__card {
    display: flex;
    flex-direction: column;
    width: 29.75rem;
    max-width: 90%;
    background-color: $color-white;
    box-shadow:
      0px 4px 16px 0px rgba(0, 0, 0, 0.12),
      0px 16px 32px -4px rgba(9, 9, 45, 0.08);
    border-radius: 12px;
    padding: 1.5rem;
    z-index: 1;

    @include sm {
      padding: 3rem;
    }
  }

  .LayoutAuth__card-text {
    margin: 24px 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .LayoutAuth__card-text-title {
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    font-family: 'Foundever Sans';

    @include sm {
      font-size: 24px;
      line-height: 32px;
    }
  }

  .LayoutAuth__card-text-subtitle {
    font-size: 14px;
    font-weight: 400;
    color: $color-neutral-120;
    font-family: 'Foundever Sans';
  }

  .LayoutAuth__router-view {
    margin-top: auto;
  }

  .LayoutAuth__footer {
    position: absolute;
    bottom: 40px;
    font-family: Noto Sans;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    color: $color-white;
  }
}
</style>
